import React from 'react';
import utils from "../services/utils";


const GeneralManage = (props) => {

    return (
        <>
        <div className="welcome-section">
            <span>{utils.useLang('WELCOME')} </span>
            <span>{utils.useLang('TO_BUS')}</span>
            <select onChange={props.handleChangeBus}>{props.renderBusiness()}</select>
        </div>
        </>
)
    ;
};

export default GeneralManage;